export default __webpack_public_path__ + "static/award-2-fb2eca8983055e2e5c14b25712956dff.png";